import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: 0,
    A_RefDt: new Date(), // dd/MM/yyyy
    A_Narr: "",
    A_DocStat: "ENTER",
    //new
    A_Party: "",
    A_PartyName: "",
    A_FromLocBr: "",
    A_FromLocBrName1: "",
    A_FromLocBatch: "",
    A_FromLocName: "",
    A_FromLoc: "",

    A_Do: "N",
    AdjustmentType:""
  },

  WmsStockAdjustmentCheckbox: {
    Reason: true,
    ItemCode: true,
    Auto: true,
  },
};

const SliceStockAdjustment = createSlice({
  name: "SliceStockAdjustment",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_StockAdjustment_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_StockAdjustment_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    //RESET CHECKBOX
    Set_ModelCheckbox_Init: (state) => {
      state.value.WmsStockAdjustmentCheckbox = {
        Reason: true,
        ItemCode: true,
        Auto: true,
      };
    },

    Set_StockAdjustment_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
    Set_ModelCheckbox: (state, action) => {
      state.value.WmsStockAdjustmentCheckbox = action.payload;
    },

    StockAdjustment_HeadObject_New_Set: (state, action) => {
      state.value.HeadObject.A_VocTyp = action.payload.A_VocTyp;
      state.value.HeadObject.A_VocTypName = action.payload.A_VocTypName;
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_FromLocBr = action.payload.A_FromLocBr;
      state.value.HeadObject.A_FromLocBatch = action.payload.A_FromLocBatch;
      state.value.HeadObject.A_FromLoc = action.payload.A_FromLoc;
      state.value.HeadObject.AdjustmentType = action.payload.AdjustmentType;
    },

    StockAdjustment_HeadObject_Party_Set: (state, action) => {
      state.value.HeadObject.A_Party = action.payload.A_Party;
      state.value.HeadObject.A_PartyName = action.payload.A_PartyName;
      state.value.HeadObject.CreditLimit = action.payload.CreditLimit;
      state.value.HeadObject.OsAmount = action.payload.OsAmount;
      state.value.HeadObject.AvlAmt = action.payload.AvlAmt;
    },

    Set_StockAdjustment_HeadObject_A_VocNo: (state, action) => {
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },

    Set_StockAdjustment_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
  },
});

export const {
  Set_StockAdjustment_Init,
  Set_StockAdjustment_HeadObject_Set,
  Set_ModelCheckbox,
  Set_ModelCheckbox_Init,
  StockAdjustment_HeadObject_New_Set,
  Set_StockAdjustment_HeadObject_Init,
  Set_StockAdjustment_HeadObject_A_VocNo,
  Set_StockAdjustment_HeadObject_A_DocStat,
  StockAdjustment_HeadObject_Party_Set,
} = SliceStockAdjustment.actions;
export default SliceStockAdjustment.reducer;
